import { NoddiDateRangePicker, NoddiDateRangePickerProps } from '@ui-components/Overlay/Date/NoddiDateRangePicker';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type DateRange = { from: Date | undefined; to: Date | undefined };

type Props = Omit<NoddiDateRangePickerProps, 'dateRange' | 'onDateChange'>;

export const TanstackFormDateRangePicker = (rest: Props) => {
  const field = useFieldContext<DateRange>();
  const fieldAria = useTanstackFieldAria(field, rest['aria-describedby']);
  const { from, to } = field.state.value;

  return (
    <div>
      <NoddiDateRangePicker
        {...rest}
        id={rest.id ?? field.name}
        name={field.name}
        {...fieldAria}
        dateRange={from || to ? { from, to } : undefined}
        onDateChange={(range) => {
          field.handleChange({ from: range?.from, to: range?.to });
        }}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
